import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { cotizaAvanzado } from '../entidades/cotizaAvanzado';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CotizacionService {

  private origenSource = new BehaviorSubject<string>('');
  origen = this.origenSource.asObservable();

  private destinoSource = new BehaviorSubject<string>('');
  destino = this.destinoSource.asObservable();

  private cotizaSource = new BehaviorSubject(new cotizaAvanzado());
  cotizacion = this.cotizaSource.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  public setOrigen(value) {
    this.origenSource.next(value);
  }
  public setDestino(value) {
    this.destinoSource.next(value);
  }

  getCotizacion(origen, destino, peso, uuid, correo, telefono, envioDescripcion) {
    const c = correo || " ";
    const t = telefono || " ";
    const d = envioDescripcion || " ";
    let url = `${environment.URL_APIPAQ}/obtenerCotizacion?cpo=${origen}&cpd=${destino}&Peso=${peso}&uuid=${uuid}&correo=${c}&telefono=${t}&envioDescripcion=${d}`
    return this.http.get(url);
  }

  regsolcotizacion(opr, idcot, apellido, nombre, correo, telefono, numref, tipo, tipoEnvio, envioDescripcion) {
    const ape = apellido || " ";
    const nom = nombre || " ";
    const corr = correo || " ";
    const tel = telefono || " ";
    const desc = envioDescripcion || " ";
    let url = `${environment.URL_APIPAQ}/regsolcotizacion?opr=${opr}&idcot=${idcot}&apellido=${ape}&nombre=${nom}&correo=${corr}&telefono=${tel}&numref=${numref}&tipo=${tipo}&tipoEnvio=${tipoEnvio}&envioDescripcion=${desc}`
    return this.http.get(url);
  }

  getCotizacionAvanzada(origen, destino, tipoPaquete, cantidad, largo, alto, ancho, peso, scobrar, sseguro, monto, sdomicilio, dirdom, sreco, dirreco, sembalaje, sacuse, embalaje, uuid, correo) {
    let url = `${environment.URL_APIPAQ}/cotizacionAvanzada?origen=${origen}&destino=${destino}&tipoPaquete=${tipoPaquete}&cantidad=${cantidad}&largo=${largo}&alto=${alto}&ancho=${ancho}&peso=${peso}&scobrar=${scobrar}&sseguro=${sseguro}&monto=${monto}&sdomicilio=${sdomicilio}&dirdom=${dirdom}&sreco=${sreco}&dirreco=${dirreco}&sembalaje=${sembalaje}&sacuse=${sacuse}&embalaje=${embalaje}&uuid=${uuid}&correo=${correo}`

    this.http.get<cotizaAvanzado>(url).subscribe(
      datos => {
        this.cotizaSource.next(datos);
      }
    )
  }

  getCiudades() {
    let url = `${environment.URL_APIPAQ}/obtenerSucursales`
    return this.http.get(url);
  }

  getdirectorio(cp, tipo) {
    //cambiar a URL_API antes de publicar
    let url = `${environment.URL_API}/logDirectorioDirecciones3?codigo=${cp}&tipo=${tipo}`
    return this.http.get(url);
  }

  getregcorr(uuid) {
    let url = `${environment.URL_APIPAQ}/getevreg?uuid=${uuid}`
    return this.http.get(url);
  }

  getOrigenesVolaris() {
    const url = `${environment.URL_APIPAQ_TEST}/wsgetorigenvolaris?idusr=0`;
    return this.http.get(url);
  }

  getDestinosVolaris(origen: string) {
    const url = `${environment.URL_APIPAQ_TEST}/wsgetdestinosvolaris?idusr=0&origen=${origen}`;
    return this.http.get(url);
  }
  getCotizacionVolaris(
    origen: string,
    destino: string,
    largo: number,
    alto: number,
    ancho: number,
    peso: number,
    nombre: string,
    correo: string,
    telefono: string
  ) {
    const url = `${environment.URL_APIPAQ_TEST}/wsgetcotizacionvolaris` +
      `?idusr=0` +
      `&origen=${encodeURIComponent(origen)}` +
      `&destino=${encodeURIComponent(destino)}` +
      `&largo=${largo}` +
      `&alto=${alto}` +
      `&ancho=${ancho}` +
      `&peso=${peso}` +
      `&nombre=${encodeURIComponent(nombre)}` +
      `&correo=${encodeURIComponent(correo)}` +
      `&telefono=${encodeURIComponent(telefono)}`;

    return this.http.get(url);
  }

  getDireccionOrigen(origen: string) {
    const url = `${environment.URL_APIPAQ_TEST}/wsgetdireccionorigen?idusr=0&origen=${origen}`;
    return this.http.get(url);
  }

}
